module.exports = {
  language: 'Turkish',
  nationalityKay: 'tr-tr',
  noneSelectedText: 'Lütfen seçiniz',
  multiselect: {
    deselect: "Kaldırmak için Enter'a basın",
    select: "Seçmek için Enter'a basın",
    selected: 'Seçildi'
  },
  enter: ' Girmek',
  upload_failed: 'Yükleme başarısız oldu, lütfen tekrar deneyin',
  due_time: 'teslim süresi',
  requirement: 'Gereklilik',
  something_went_wrong_please_retry: 'Something went wrong, please retry',
  valid_rediret_home_page_popup_content:
    "Oturum açma istisnası oluştu. Giriş yapmak için [ {country} - {center} ] ana sayfasına gitmeye mi çalışıyorsunuz? Evet ise, lütfen 'Onayla'yı tıklayın; hayır ise, tekrar seçmek için lütfen 'İptal'i tıklayın.",
  invalid_rediret_home_page_popup_content: 'Giriş istisnası oluştu, lütfen devam etmek için ülke ve konum seçin.',
  'Temporarily not available': 'Geçici olarak mevcut değil',
  'Coming soon': 'Çok yakında'
};
